import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { PlacementAssuranceVieResponse } from '@/api';
import ModaleDefaut from '@/components/ModaleDefaut/ModaleDefaut';
import { ROUTE } from '@/constants/route';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';
import ContentModalRepartition from '@/modals/ContentModalRepartition/ContentModalRepartition';
import { Support } from '@/services/types/commonResponse';
import { useUserStore } from '@/store/useStore';

import styles from './styles.module.css';

const CardDistributionSupport = ({
  color,
  produitName,
  montant,
  completed,
  supports,
  data,
}: CardDistributionSupportProps) => {
  const { t } = useTranslation();
  const userConseiller = useUserStore((state) => state.user);
  const navigate = useNavigate();

  const [showModaleRepartition, setShowModaleRepartition] = useState(false);
  const [groupeSupport, setGroupeSupport] = useState<Support[]>();

  const circleStyle = {
    width: '20px',
    height: '20px',
    borderRadius: '99px',
  };

  const openModal = (cProduitName: string) => {
    document.body.classList.add('modal-open');
    setShowModaleRepartition(true);

    const supportsCategories = supports.filter((support) => support.libelleCategorieSupport === cProduitName);
    setGroupeSupport(supportsCategories);
  };

  const closeModal = () => {
    setShowModaleRepartition(false);
  };

  const handleFaireVersement = () => {
    closeModal();
    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'faire un versement',
      event_detail_1: 'cta bandeau',
    });
    navigate(ROUTE.SELECTOPERATION, {
      state: {
        key: 'versement',
        placementId: data?.placementId,
        infoContrat: data,
        famille: data?.famille,
      },
    });
  };

  return (
    <>
      {showModaleRepartition && (
        <ModaleDefaut
          content={
            <ContentModalRepartition produitName={produitName} montant={montant} groupeSupport={groupeSupport} />
          }
          btnLabel="Faire un versement"
          btnVariant="primary"
          btnSize="large"
          btnFullwidth={false}
          onClickBtn={() => handleFaireVersement()}
          onClickClose={() => closeModal()}
          mobileStyle="defaut"
          size="large"
          disabled={!!userConseiller?.advisorView}
        />
      )}

      <div className={styles.cardDistributionSupport}>
        <div className={styles.infoCardDistributionSupport}>
          <div className={styles.supportTitleCardDistributionSupport}>
            <div style={{ ...circleStyle, backgroundColor: color }} />
            <p className={styles.colorTitleSupport}>{produitName} </p>
          </div>
          <div className={styles.detailsSupport}>
            <h1>{montant === null ? 0 : t('format.currencyFlexible', { value: montant })} </h1>
            <span>{completed !== null && <span>({t('format.percentFlexible', { value: completed })})</span>}</span>
          </div>
        </div>
        <div className={styles.buttoncardDistributionSupport}>
          <button className={styles.buttoncardDistributionSupport} onClick={() => openModal(produitName)}>
            <i className="totem-icon totem-icon-dots" />
          </button>
        </div>
      </div>
    </>
  );
};

export interface CardDistributionSupportProps {
  produitName: string;
  montant: number;
  color: string;
  completed?: number;
  supports: Support[];
  data?: PlacementAssuranceVieResponse;
}

export default CardDistributionSupport;
